import urls from "urls";
import { getFirebaseIDToken } from "../firebase/firebase";

/**
 * Aanroepen van de CMS-auth-endpoints in de API (CmsAuthController):
 * inloggen met een e-mailcode en gebruikers uitnodigen.
 *
 * Fouten komen als Error met `status` (HTTP) en `code` (machineleesbaar, uit
 * ErrorResponse.details: INVALID_CODE, EXPIRED, TOO_MANY_ATTEMPTS,
 * TOO_MANY_REQUESTS, ALREADY_CMS_USER, FORBIDDEN, ...).
 */
const postJson = async (url, body, headers = {}) => {
  let response;
  try {
    response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...headers },
      body: JSON.stringify(body),
    });
  } catch (networkError) {
    const error = new Error("NETWORK_ERROR");
    error.code = "NETWORK_ERROR";
    error.status = 0;
    throw error;
  }
  let data = null;
  try {
    data = await response.json();
  } catch (e) {
    data = null;
  }
  if (!response.ok) {
    const error = new Error(data?.message || `HTTP ${response.status}`);
    error.status = response.status;
    error.code = data?.details || "UNKNOWN";
    throw error;
  }
  return data;
};

/** Vraagt een inlogcode aan. Antwoord is altijd gelijk, ook voor onbekende adressen. */
export const requestLoginCode = (email) => postJson(urls.cmsAuthRequestCode, { email });

/** Controleert de code; geeft `{ token }` (Firebase custom token) terug. */
export const verifyLoginCode = (email, code) => postJson(urls.cmsAuthVerifyCode, { email, code });

/**
 * Nodigt een gebruiker uit (of koppelt een bestaand webshopaccount). Vereist
 * een ingelogde beheerder; het ID-token gaat mee als Authorization-header.
 * @param {{email: string, role: string, salesCountries?: string[], salesCustomerIds?: string[], cmsPermissions?: object}} payload
 * @returns {Promise<{uid: string, linked: boolean}>}
 */
export const inviteCmsUser = async (payload) => {
  const idToken = await getFirebaseIDToken();
  return postJson(urls.cmsUsersInvite, payload, { Authorization: idToken });
};
